import { createContext } from "react";
import { IClientQuery } from "../../../models/client/query";
import { IMedictionPackage } from "../../../models/client/response";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import {
  DEFAULT_FUNCTION,
  DEFAULT_QUERY,
} from "../../../utils/helpers/constants";

export type ClientLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: ClientLoading[];
  listMedicationPackage?: IBaseListingResponse<IMedictionPackage>;
  query: IClientQuery;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getListMedicationPackage: (id: number) => void;

    setSearch: (search?: string) => void;
    setQuery: (query: IClientQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getListMedicationPackage: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const MedicationPackageClientContext = createContext(externalState);

export default MedicationPackageClientContext;
